import { createFileRoute } from "@tanstack/react-router";
import { Paper, Title, Text, Stack, Box } from "@mantine/core";
import { ChangePasswordForm } from "@/components/auth";

export const Route = createFileRoute("/_authenticated/change-password")({
  component: ChangePasswordPage,
});

function ChangePasswordPage() {
  return (
    <Box maw={500} mx="auto">
      <Paper p="md" radius="md" withBorder style={{ borderColor: "#0f3460" }}>
        <Stack gap="md">
          <Title order={2}>Change Password</Title>
          <Text c="dimmed">You must change your password before continuing.</Text>
          <ChangePasswordForm />
        </Stack>
      </Paper>
    </Box>
  );
}
